module.exports = __webpack_public_path__ + "img/527-86bfa6.png";